import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../../components/button'
import { Loader } from '../../../../../components/loader'
import { PageContainer } from '../../../../../components/page-container/page-container'
import { Pin } from '../../../../../components/pin'
import { showToast } from '../../../../../components/sonner'
import type { RootState } from '../../../../../redux/global-store'
import { paths } from '../../../../../router/paths'
import { changePasswordResetRequest, resetPasswordRequest } from '../../../presentation/redux/actions/reset-password-actions'

export const ConfirmNewPin = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [pin, setPin] = useState('')

  const load = useSelector((state: RootState) => state.user.resetPassword.load)
  const error = useSelector((state: RootState) => state.user.resetPassword.error)
  const success = useSelector((state: RootState) => state.user.resetPassword.success)
  const resetPasswordFlow = useSelector((state: RootState) => state.user.resetPassword.resetPasswordFlow)
  const resetPasswordCompleted = useSelector((state: RootState) => state.user.resetPassword.resetPasswordCompleted)
  const changePasswordCompleted = useSelector((state: RootState) => state.user.resetPassword.changePasswordCompleted)

  const [resetPasswordCalled, setResetPasswordCalled] = useState(false)

  const handleCreatePin = () => {
    // Valida se o PIN confirmado é igual ao criado
    if (pin !== resetPasswordFlow.newPin) {
      showToast('Los PINs no coinciden. Intente nuevamente.', 'error')
      return
    }

    // Primeiro chama User/ResetPassword para gerar o JWT
    setResetPasswordCalled(true)
    dispatch(
      resetPasswordRequest({
        code: resetPasswordFlow.token,
        taxId: resetPasswordFlow.taxId,
      })
    )
  }

  // Listen for successful resetPassword, then call changePassword
  useEffect(() => {
    if (resetPasswordCompleted && resetPasswordFlow.jwtToken && !changePasswordCompleted) {
      // Agora chama a API para alterar a senha com o JWT
      dispatch(
        changePasswordResetRequest({
          params: {
            UserId: resetPasswordFlow.userId!,
            NewPassword: pin,
            ConfirmationNewPassword: pin,
          },
          jwtToken: resetPasswordFlow.jwtToken,
        })
      )
    }
  }, [resetPasswordCompleted, changePasswordCompleted, resetPasswordFlow.jwtToken, dispatch, resetPasswordFlow.userId, pin])

  // Listen for successful password change (only navigate on final success)
  useEffect(() => {
    if (changePasswordCompleted) {
      navigate(paths.user.resetPassword.resetSuccess)
    }
  }, [changePasswordCompleted, navigate])

  // Show error messages
  useEffect(() => {
    if (error) {
      showToast(error, 'error')
    }
  }, [error])

  return (
    <PageContainer
      type="unauthenticated"
      footerClass='flex w-full flex-col items-center justify-between gap-12 px-8'
      footer={
        <div className="flex w-full flex-col py-12">
          <p className="px-8 pb-6 text-start text-sm font-normal text-[#736969]">
            *Confirme su PIN, debe ser el mismo que ingresó en la anterior
            pantalla
          </p>
          <div className="flex w-full justify-center">
            {load && <Loader />}
            <Button
              className="h-[55px] w-full rounded-[10px] text-xl font-semibold"
              onClick={handleCreatePin}
              disabled={pin.length !== 4 || load}
            >
              {load ? 'Creando...' : 'Crear PIN'}
            </Button>
          </div>
        </div>
      }
    >
      <div className="bg-primary-darkest flex h-20 w-full items-center justify-center">
        <p className="text-2xl font-normal text-white">Confirmar PIN</p>
      </div>
      <div className="flex w-full flex-col items-center justify-between gap-12 px-8">
        <div className="flex w-full flex-col gap-2 pt-8">
          <p className="pb-6 text-center text-lg font-normal">Confirme PIN</p>
          <div className="flex flex-col gap-8">
            <Pin onChange={setPin} type="pin" />
          </div>
        </div>
      </div>
    </PageContainer>
  )
}